jQuery( function( $ ) {
	$( document ).ready( function() {
		$( 'ul.tabs li' ).click( function() {
			const tabID = $( this ).attr( 'data-tab' );

			$( 'ul.tabs li' ).removeClass( 'current' );
			$( '.tab-content' ).removeClass( 'current' );

			$( this ).addClass( 'current' );
			$( '#' + tabID ).addClass( 'current' );
		} );
	} );

	$( '.archive-download__btn' ).on( 'click', function() {
		$( '.archive-product__select:checked' ).each( function() {
			$( this ).parent( 'a' ).siblings( '.download-icon' )[ 0 ].click();
		} );
	} );

	$( '.archive-download__btn-all' ).on( 'click', function() {
		$( '.download-icon' ).each( function() {
			$( this )[ 0 ].click();
		} );
	} );

	$( '.open' ).on( 'click', function() {
		$( '.popup-overlay, .popup-content' ).addClass( 'active' );
	} );

	$( '.close, .popup' ).on( 'click', function() {
		$( '.popup-overlay, .popup-content' ).removeClass( 'active' );
	} );

	// Market selector on product archive.
	$( '.en' ).css( { display: 'block' } );

	$( '#reseller-select-store-select' ).on( 'change', function() {
		$( '.additional-info' ).css( 'display', 'none' );
		$( '.long-product-description' ).css( 'display', 'none' );

		const url = $( this ).val(); // get selected value
		if ( url ) { // require a URL
			$( '.' + url ).toggle();
		}

		$( '.additional-market' ).text( url );
	} );
} );
